"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var __1 = tslib_1.__importDefault(require("../.."));
var TypedObjectAccessor_1 = tslib_1.__importDefault(require("./TypedObjectAccessor"));
var SSPContentFieldAccessor = (function (_super) {
    tslib_1.__extends(SSPContentFieldAccessor, _super);
    function SSPContentFieldAccessor(model) {
        var _this = _super.call(this) || this;
        _this._forceCurrentLanguage = false;
        _this._model = model;
        _this._langLookup = new TypedObjectAccessor_1.default();
        _this.update(model);
        return _this;
    }
    Object.defineProperty(SSPContentFieldAccessor.prototype, "forceCurrentLanguage", {
        get: function () {
            return this._forceCurrentLanguage;
        },
        set: function (val) {
            this._forceCurrentLanguage = val;
        },
        enumerable: false,
        configurable: true
    });
    SSPContentFieldAccessor.prototype.update = function (model) {
        this._model = model;
        this.target = this._model._acc.obj('ContentFieldValues');
        this._langLookup.target = this._model._acc.obj('FieldMultilingual');
    };
    SSPContentFieldAccessor.prototype.isMultilingual = function (contentFieldId) {
        return this._langLookup.bool(contentFieldId);
    };
    Object.defineProperty(SSPContentFieldAccessor.prototype, "contentTreeChildren", {
        get: function () {
            return this._model._acc.reflist('ContentTreeChildren', false);
        },
        enumerable: false,
        configurable: true
    });
    SSPContentFieldAccessor.prototype.references = function (uid) {
        if (!__1.default.instance.modelExists(uid)) {
            return false;
        }
        var childToLookFor = __1.default.instance.getContentModel(uid);
        return this.contentTreeChildren.indexOf(childToLookFor) >= 0;
    };
    SSPContentFieldAccessor.prototype.raw = function (contentFieldId, valueIfNotExisting) {
        if (valueIfNotExisting === void 0) { valueIfNotExisting = null; }
        if (!this.has(contentFieldId)) {
            return valueIfNotExisting;
        }
        else if (this.isMultilingual(contentFieldId)) {
            var obj = this._target[contentFieldId];
            var lccc = this._model.getLanguage();
            if (lccc in obj) {
                return obj[lccc];
            }
            else if (this._forceCurrentLanguage) {
                return valueIfNotExisting;
            }
            else {
                var languages = Object.keys(obj);
                if (languages.length > 0) {
                    return obj[languages[0]];
                }
                else {
                    return valueIfNotExisting;
                }
            }
        }
        else {
            return this._target[contentFieldId];
        }
    };
    SSPContentFieldAccessor.prototype.addValue = function (key, value) {
        var lccc = this._model.getLanguage();
        var fieldObj;
        if (this.has(key)) {
            if (!this.isMultilingual(key)) {
                fieldObj = {};
                fieldObj[lccc] = this._target[key];
                this._target[key] = fieldObj;
            }
            else {
                this._target[key][lccc] = value;
            }
        }
        else {
            fieldObj = {};
            fieldObj[lccc] = value;
            this._target[key] = fieldObj;
        }
        this._langLookup.addValue(key, true);
    };
    return SSPContentFieldAccessor;
}(TypedObjectAccessor_1.default));
exports.default = SSPContentFieldAccessor;
